(function (Drupal) {
  Drupal.behaviors.clinicMap = {
    attach: function (context, settings) {
      const cards = context.querySelectorAll('.view-clinic');
      if (cards.length === 0) return;

      const buttons = context.querySelectorAll('.view-clinic .card-clinics .btn');      
      if (!buttons) return;

      const script = document.createElement('script');
      script.id = 'googleMapsScript'; // Añade un ID para evitar cargas duplicadas
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAkiYK_x_I4B2kzyoP5YdHRH2c19fq9Yts';
      script.type ="text/javascript"
      document.body.append(script);

      buttons.forEach(button => {        
        button.addEventListener('click', function () {          
          const cardClinics = button.closest('.card-clinics');
          if (!cardClinics) return;

          const cardBody = cardClinics.querySelector('.card-body');
          const coordenadas = cardClinics.querySelector('.card-body .geolocation-latlng');

          if (!cardBody) return;
          if (!coordenadas) return;

          const clonedCardBody = cardBody.cloneNode(true);

          let modalBody = document.querySelector('#map-clinic .modal-body .info');
          let modalBodyMap = document.querySelector('#map-clinic .modal-body .render-map');
          
          const listGroupName = cardClinics.querySelector('.list-group__name');
          const locationName = listGroupName ? listGroupName.innerText : '';
          const cardClinicsContact = button.closest('.contact-cards-clinics');

          if (cardClinicsContact) {
            modalBody = document.querySelector('#map-clinic-reina .modal-body .info');
            modalBodyMap = document.querySelector('#map-clinic-reina .modal-body .render-map');
          }
          const ctaUrlClinic = cardClinics.querySelector(".cta-url-clinic");
          if(!ctaUrlClinic) {
            modalBody.closest(".modal-content").querySelector(".modal-footer").classList.add("only-btn-center")
          } else {
            modalBody.closest(".modal-content").querySelector(".modal-footer").classList.remove("only-btn-center")
          }
          modalBody.innerHTML = '';
          modalBody.appendChild(clonedCardBody);
          initMap(coordenadas, locationName);
        });
      });
    }
  };

  function initMap(coordenadas, locationName) {
    const [lat, lng] = coordenadas.innerText.split(',').map(Number);
    const mapElement = document.querySelectorAll('.render-map');
    mapElement.forEach(element => {
      
      const location = { lat: parseFloat(lat), lng: parseFloat(lng) };
      const map = new google.maps.Map(element, {
          zoom: 15,
          center: location
      });
  
      const marker = new google.maps.Marker({
      //const marker = new google.maps.marker.AdvancedMarkerElement({
          position: location,
          map: map,
          title: locationName,
          icon: {
            path: google.maps.SymbolPath.SQUARE,
            scale: 5,
          } 
      });
  
      const infoWindowContent = `
        <div style="
            font-size: 14px;
            color: #000;
            text-align: center;
            font-family: 'Figtree SemiBold', sans-serif;
            font-style: initial;
            line-height: 1.5;
            padding: 0 0 0 15px;
        ">${locationName}</div>
      `;
  
      const infoWindow = new google.maps.InfoWindow({
          content: infoWindowContent
      });
  
      marker.addListener('click', function() {
        infoWindow.open(map, marker);
      });
  
      infoWindow.open(map, marker);
    });
  }
})(Drupal);
